import { STORE_DIRECT_OFFER } from 'common/constants/actionTypes'

const initialState = {}

export default function (state = initialState, action) {
  switch (action.type) {
    case STORE_DIRECT_OFFER:
      return action.payload[0] || initialState
    default:
      return state
  }
}
